/**
 * Mutations for updating the state via actions.
 * Names should reference from mutation types
 */

import * as types from "./mutation-types";

export const mutations = {
  [types.SET_FEED](state, payload) {
    state.questions = payload;
  },

  [types.SET_USER_FEED](state, payload) {
    state.my_questions = payload;
  },

  [types.SET_FEED_SIZE](state, size) {
    state.props.limit = size;
  },
  [types.SET_MAX_QUERY_SIZE](state, limit) {
    state.largestQuerySize = limit;
  },
	[types.SET_STATUS](state, status) {
		state.status = status
	}
};
